import { render, staticRenderFns } from "./epms1030.vue?vue&type=template&id=0108c830&scoped=true"
import script from "./epms1030.vue?vue&type=script&lang=js"
export * from "./epms1030.vue?vue&type=script&lang=js"
import style0 from "./epms1030.vue?vue&type=style&index=0&id=0108c830&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0108c830",
  null
  
)

export default component.exports